// @ts-nocheck
import store from "../../store"
import mime from "mime"
import api from "../../../api/axios"

export default async function viewServerFile({ url, filename, token, download }) {
	const { user } = store

	const config = { responseType: "arraybuffer" }
	if (Boolean(user)) config.headers = { Authorization: `Bearer ${user.token}` }
	if (Boolean(token)) config.headers = { Authorization: `Bearer ${token}` }

	const response = await api.get(url, config)
	const mimeType = response.headers["content-type"]

	let extension = mime.getExtension(mimeType)
	if (!extension && mimeType === "text/plaintext; charset=utf-8") extension = "txt"

	if (!filename) filename = response.headers["x-filename"]
	filename = filename.split(".")

	if (filename[filename.length - 1] === extension) {
		filename = filename.join(".")
	} else if (filename[filename.length - 1] === "jpg" && extension === "jpeg") {
		filename = filename.join(".")
	} else {
		filename = filename.join(".")
		filename = `${filename}.${extension}`
	}

	const blob = new Blob([response?.data], { type: mimeType })
	const path = window.URL.createObjectURL(blob)

	if (download) {
		const link = document.createElement("a")
		link.href = path
		link.download = filename

		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}

	window.open(path, "_blank")
	window.URL.revokeObjectURL(path)
}
